<!-- 模拟玩家游戏画面 -->
<template>
  <div class="game-1">
    <div>
      <div class="game-1-box">
        <div>
          <Game2
            v-if="gameInfo.gameType == 2"
            :value.sync="form"
            :cardList="cardList"
            :gameInfo="gameInfo"
            :userInfo="userInfo"
            @confirm="saveRecord"
          />
          <Game3
            ref="game3Ref"
            v-if="gameInfo.gameType == 3"
            :cardList="cardList"
            :gameInfo="gameInfo"
            :userInfo="userInfo"
            :gameStatus="gameStatus"
            :game3List.sync="game3List"
            :game3Lock="game3Lock"
            @confirm="saveRecord"
          />
          <Game4
            v-if="gameInfo.gameType == 4"
            :cardList="cardList"
            :value.sync="form"
            :gameInfo="gameInfo"
            :userInfo="userInfo"
            :gameStatus="gameStatus"
            @confirm="saveRecord"
          />
          <Game6
            v-if="gameInfo.gameType == 6"
            :cardList="cardList"
            :value.sync="form"
            :gameInfo="gameInfo"
            :userInfo="userInfo"
            :gameStatus="gameStatus"
            @confirm="saveRecord"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  Empty,
  ImagePreview,
  Icon,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
import NfBrand from "@/components/game-ui/NfBrand.vue";
import FrontSelectListVue from "@/components/game-comm/FrontSelectList.vue";
import WheelRecord from "@/components/game-comm/WheelRecord.vue";
import { getGameConfigByTag } from "../../config";
import $store from "@/store";
import { getRoundConfig, getCardList } from "@/api/game";
import Game2 from "./game-2.vue";
import Game3 from "./game-3.vue";
import Game4 from "./game-4.vue";
import Game6 from "./game-6.vue";

export default {
  props: {},
  data() {
    return {
      userInfo: {},
      cardList: [],
      gameInfo: {
        gameId: 1,
        gameRoundId: 1,
        cateId: 4,
        secondCateId: 5,
        gameType: null,
      },
      form: {
        // 玩家选择的角色
        roleTab: 0,
        selectCardList: [],

        // 所有玩家列表
        playerList: [],
        // 玩家选择的卡牌列表
        playerCardList: {},
        // 成功保存后的用户
        successSaveUser: [],
      },
      game3List: [
        {
          name: "同伴",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 129, 129)",
          borderColor: "rgba(255, 129, 129)",
        },
        {
          name: "异性",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 195, 125)",
          borderColor: "rgba(255, 195, 125, 2)",
        },
        {
          name: "老师",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(92, 211, 231)",
          borderColor: "rgba(92, 211, 231)",
        },
        {
          name: "学习",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 215, 39)",
          borderColor: "rgba(255, 215, 39)",
        },
        {
          name: "自我",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(97, 216, 81)",
          borderColor: "rgba(97, 216, 81)",
        },
        {
          name: "兴趣",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(193, 169, 253)",
          borderColor: "rgba(193, 169, 253)",
        },
        {
          name: "娱乐",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(230, 118, 247)",
          borderColor: "rgba(230, 118, 247)",
        },
        {
          name: "家庭",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(110, 144, 255)",
          borderColor: "rgba(110, 144, 255)",
        },
        {
          name: "偶像",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(93, 193, 156)",
          borderColor: "rgba(93, 193, 156)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 129, 129)",
          borderColor: "rgba(255, 129, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(155, 109, 129)",
          borderColor: "rgba(155, 109, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(55, 129, 119)",
          borderColor: "rgba(55, 129, 119)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(155, 29, 129)",
          borderColor: "rgba(155, 29, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(5, 129, 19)",
          borderColor: "rgba(5, 129, 129)",
        },
      ],
    };
  },
  components: {
    NfCard,
    NfButton,
    Swipe,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    NfBrand,
    FrontSelectListVue,
    Empty,
    WheelRecord,
    ImagePreview,
    Icon,
    Game2,
    Game3,
    Game4,
    Game6,
  },
  mounted() {
    this.userInfo = this.$store.state.app.userInfo;

    this.getGameInfo();
  },
  methods: {
    getGameInfo() {
      getRoundConfig({ gameId: this.$route.query.gameId }).then((res) => {
        if (res.success) {
          Object.assign(this.gameInfo, res.data.cardGameRound);
          this.gameInfo.gameRoundId = res.data.cardGameRound.id;
          this.gameInfo.gameName = res.data.gameName;
          this.gameInfo.openSync = res.data.cardGameRound.openSync;
          this.gameInfo.gameStatus = res.data.gameStatus;
          const config = getGameConfigByTag(this.gameInfo.tag);
          Object.assign(this.gameInfo, config);
          this.getCardList();
        }
      });
    },
    // 获取卡牌列表
    getCardList() {
      const data = {
        gameId: this.gameInfo.gameId,
        cateId: this.gameInfo.cateId,
        secondCateId: this.gameInfo.secondCateId,
        // cateId: 4,
        // secondCateId: 5,
      };
      getCardList(data).then((res) => {
        if (res.success) {
          this.cardList = res.data;
          // 如果为暗抽、九宫格，随机抽9张牌

          // 如果为盲抽，抽25张牌
          if (
            this.gameInfo.secondCateId == 11 ||
            this.gameInfo.secondCateId == 16
          ) {
            // 随机25张
            this.cardList = this.cardList.sort(() => {
              return Math.random() - 0.5;
            });
            this.cardList = this.cardList.slice(0, 25);
          }
        }
      });
    },
    saveRecord() {},
  },
  computed: {
    formValue: {
      get: () => {
        return $store.state.game.discus.form;
      },
      set: (val) => {
        $store.commit("GAME_DISCUS_FORM", val);
      },
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }

    &-list {
      ::v-deep .van-grid-item__content {
        padding: 0.2rem;
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }
      }

      &-open {
        position: absolute;
        top: -0.15rem;
        right: -0.15rem;
        border-radius: 50%;
        width: 0.6rem;
        height: 0.6rem;
        background: #eee;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      &-left {
      }
      &-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-item {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
          }
        }
      }
    }
  }

  ::v-deep .van-grid {
    justify-content: center;
  }
}
</style>
